// 瑞典语

export default{
    shipping_method: 'Fraktmetod',
    shipping_time: 'Leveranstid',
    costs: 'Kostnader',
    shipping_to: 'Skickas till'
}


// WEBPACK FOOTER //
// ./src/i18n/sv.js